import { render } from "./header.vue?vue&type=template&id=5fc3d2a2&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=5fc3d2a2&lang=less&scoped=true"
import "./header.vue?vue&type=style&index=1&id=5fc3d2a2&lang=less"

import exportComponent from "E:\\project\\eyes-system\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fc3d2a2"]])

export default __exports__